export default __webpack_public_path__ + "static/EDM-157350e5254e208aee8ac70d3afd1484.png";